/**
 * Soodam reviews preview — smooth jump to the full reviews section.
 *
 * The review glimpse under the PDP title carries an anchor to #reviews. This
 * upgrades that jump to a smooth scroll that re-snaps after lazy-loaded media
 * above the target settles: the PDP is ~12,000px tall and the gallery below the
 * fold lazy-loads, so a plain hash jump computes the target too early and lands
 * ~800px short. Re-running scrollIntoView once the animation finishes corrects it.
 *
 * One document-level delegated listener lets it survive section morphs on
 * variant change. Loaded once globally from
 * snippets/scripts.liquid. Without JS the anchor's native href="#reviews" still
 * works (just instant).
 */

const TRIGGER = '[data-soodam-reviews-jump]';

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest(TRIGGER) : null;
  if (!link) return;

  const target = document.getElementById('reviews');
  if (!target) return; // fall back to the native href

  event.preventDefault();

  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

  if (!reduceMotion) {
    setTimeout(() => target.scrollIntoView({ behavior: 'auto', block: 'start' }), 700);
  }
});
